import { render, staticRenderFns } from "./ScreeningHistoryPaginator.vue?vue&type=template&id=776db288&scoped=true&"
import script from "./ScreeningHistoryPaginator.vue?vue&type=script&lang=js&"
export * from "./ScreeningHistoryPaginator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776db288",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VPagination } from 'vuetify/lib/components/VPagination';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VPagination,VSelect,VSpacer,VToolbar,VToolbarItems})
